<div class="loading">
  <!-- <img class="light-loader" src="assets/img/svg/Light-loader.gif" width="10%" alt="loader" srcset=""> -->
 
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  
  
  
  <div class="loader-text" [innerHtml]="text"></div>

  <br>

  <!-- <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div> -->

</div>
